/**
 * Created by 高春超 on 2018/3/3.
 */

var Message = function() {
  var a = window;
  var b = this;
  this.callbackList = [];
  this.send = function(d, c) {
    if (a.postMessage) {
      d.postMessage(c, "*")
    } else {
      d.name = c
    }
  };
  this.on = function(c) {
    if (typeof c !== "function") {
      return
    }
    this.callbackList.push(c)
  };
  this._trigger = function(d) {
    for (var c = 0; c < this.callbackList.length; c++) {
      this.callbackList[c].call(a, d)
    }
  };
  if (a.postMessage) {
    if (a.addEventListener) {
      a.addEventListener("message", function(c) {
        b._trigger(c.data)
      }, false)
    } else {
      if (a.attachEvent) {
        a.attachEvent("onmessage", function(c) {
          b._trigger(c.data)
        })
      }
    }
  } else {
    a.navigator[this.name] = function(c) {
      b._trigger(c.data)
    }
  }
};


export default new Message()



// WEBPACK FOOTER //
// ./src/utils/message.js